import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

function getLocale() {
  // const langAvailable = ['fr','en'];
  // if (navigator.language
  // && langAvailable.includes(navigator.language.split('-')[0])) {
  //   return navigator.language.split('-')[0];
  // } else if (navigator.userLanguage
  //   && langAvailable.includes(navigator.userLanguage.split('-')[0])) {
  //   return navigator.userLanguage.split('-')[0];
  // }
  return 'fr';
}
export default new VueI18n({
  locale: getLocale(),
  fallbackLocale: 'fr',
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
});
